import BookDetailModal from './BookDetailModal';

export default BookDetailModal;
